<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="error-template">
        <h1>
          Oops!</h1>
        <h2>
          403 Acces Denied</h2>
        <div class="error-details" style="box-sizing: content-box;padding: 2% 20%;">
          Sorry, your access is refused due to security reasons of our server and also our sensitive data.
          Please go back to the previous page to continue browsing.
        </div>
        <div class="error-actions">
          <a [routerLink]="['/login']" class="btn btn-primary btn-lg"><span class="glyphicon glyphicon-home"></span>
            Take Me Home </a>
        </div>
      </div>
    </div>
  </div>
</div>
